import React, { Suspense, lazy } from 'react';
import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import "./css/Pages.module.css";
import './css/index.css';


const MainApp            = lazy(() => import("./pages/App"));
const NoPage             = lazy(() => import("./pages/NoPage"));
const RegisterPage       = lazy(() => import("./pages/Register"));
const LoginPage          = lazy(() => import("./pages/Login"));
const UserProjectsPage   = lazy(() => import("./pages/UserProjectsPage"));
const PublicProjectsPage = lazy(() => import("./pages/PublicProjectsPage"));
const DocsPage           = lazy(() => import("./pages/DocsPage"));
const HomePage           = lazy(() => import("./pages/HomePage"));
const PasswordReset      = lazy(() => import("./pages/PasswordReset"));
const LearningPage       = lazy(() => import("./pages/LearningPage"));
const CreateLessonPage   = lazy(() => import("./pages/CreateLessonPage"));
const LessonPage         = lazy(() => import("./pages/LessonPage"));
const EditLessonPage     = lazy(() => import("./pages/EditLessonPage"));
const PrivacyTOSPage     = lazy(() => import("./pages/TOSPage"));

// A single Suspense boundary at the router level covers all route transitions.
// The fallback is intentionally minimal — a blank page while the chunk loads
// is less jarring than a spinner that flashes for fast connections.
// If you want a loading indicator, replace null with a <PageLoader /> component.
function PageFallback() {
  return null;
}

export default function App() {
  return (
    <BrowserRouter>
      <Suspense fallback={<PageFallback />}>
        <Routes>
          <Route index element={<HomePage />} />
          <Route path="/project/:pid" element={<MainApp />} />
          <Route path="/projects" element={<UserProjectsPage />} />
          <Route path="/discover" element={<PublicProjectsPage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/register" element={<RegisterPage />} />
          <Route path="/privacy" element={<PrivacyTOSPage />} />
          <Route path="/reset" element={<PasswordReset />} />
          <Route path="/docs" element={<DocsPage />} />
          <Route path="/lessons" element={<LearningPage />} />
          <Route path="/lessons/new" element={<CreateLessonPage />} />
          <Route path="/lessons/:lid" element={<LessonPage />} />
          <Route path="/lessons/:lid/edit" element={<EditLessonPage />} />
          <Route path="*" element={<NoPage />} />
        </Routes>
      </Suspense>
    </BrowserRouter>
  );
}

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(<App />);